export const LOADING_START = 'LOADING_START'
export const LOADING_STOP = 'LOADING_STOP'



// WEBPACK FOOTER //
// ./src/store/modules/general/mutation_types.js